// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'
import auth from './authentification'

const state = {
  assetTypeList: [],
  bridgeCategoryList: [],
  bridgeWorkTypeList: [],
  buildingCategory: [],
  buildingMinistryList: [],
  buildingTypeList: [],
  buildingWorkTypeList:[],
  contractorDocumentReferentialList: [],
  contractorExperienceList: [],
  costCategoryList: [],
  designMethodList: [],
  disasterCategoryList: [],
  districtList: [],
  districtOfUserProfileList: [],
  domainList: [],
  equipmentCategoryList: [],
  equipmentWorkTypeList:[],
  fundingSourceList: [],
  functionList: [],
  irrigationCategoryList: [],
  irrigationTypeList: [],
  irrigationWorkTypeList:[],
  milestoneStatusList: [],
  procurementTypeList: [],
  projectClassList: [],
  projectPictureCategoryList: [],
  projectApplicationStatusList: [],
  projectCompletionStatusList: [],
  projectMarkList: [],
  projectStatusList: [],
  projectSectorList: [],
  projectTypeList: [],
  projectWorkTypeList: [],
  provinceList: [],
  riskCostLevelList: [],
  riskResourceAvailabilityLevelList: [],
  riskScheduleLevelList: [],
  riskScopeLevelList: [],
  riverList: [],
  roadClassList: [],
  roadSurfaceList: [],
  roadTypeList: [],
  roadWorkTypeList: [],
  userProfileList: [],
  userTypeList: [],
  villageList: [],
  yearList: [],
  instructionDocumentList: [],
  reportingDocumentList: [],
  completionDocumentList: []
}

const mutations = {
  setAssetTypeList(state, payload) {
   state.assetTypeList = payload;
  },
  setBridgeCategoryList(state, payload) {
   state.bridgeCategoryList = payload;
  },
  setBridgeWorkTypeList(state, payload) {
   state.bridgeWorkTypeList = payload;
  },
  setBuildingCategory(state, payload) {
   state.buildingCategory = payload;
  },
  setBuildingMinistryList(state, payload) {
   state.buildingMinistryList = payload;
  },
  setBuildingTypeList(state, payload) {
   state.buildingTypeList = payload;
  },
  setBuildingWorkTypeList(state, payload) {
   state.buildingWorkTypeList = payload;
  },
  setContractorExperienceList(state, payload) {
   state.contractorExperienceList = payload;
  },
  setContractorDocumentReferentialList(state, payload) {
   state.contractorDocumentReferentialList = payload;
  },
  setCostCategoryList(state, payload) {
   state.costCategoryList = payload;
  },
  setDesignMethodList(state, payload) {
   state.designMethodList = payload;
  },
  setDisasterCategoryList(state, payload) {
    state.disasterCategoryList = payload;
  },
  setDistrictList(state, payload) {
    state.districtList = payload;
  },
  setDistrictOfUserProfileList(state, payload) {
   state.districtOfUserProfileList = payload;
  },
  setDomainList(state, payload) {
   state.domainList = payload;
  },
  setEquipmentCategoryList(state, payload) {
   state.equipmentCategoryList = payload;
  },
  setEquipmentWorkTypeList(state, payload) {
   state.equipmentWorkTypeList = payload;
  },
  setFunctionList(state, payload) {
   state.functionList = payload;
  },
  setFundingSourceList(state, payload) {
   state.fundingSourceList = payload;
  },
  setIrrigationCategoryList(state, payload) {
   state.irrigationCategoryList = payload;
  },
  setIrrigationTypeList(state, payload) {
   state.irrigationTypeList = payload;
  },
  setIrrigationWorkTypeList(state, payload) {
   state.irrigationWorkTypeList = payload;
  },
  setMilestoneStatusList(state, payload) {
   state.milestoneStatusList = payload;
  },
  setProcurementTypeList(state, payload) {
   state.procurementTypeList = payload;
  },
  setProjectClassList(state, payload) {
   state.projectClassList = payload;
  },
  setProjectPictureCategoryList(state, payload) {
   state.projectPictureCategoryList = payload;
  },
  setProjectApplicationStatusList(state, payload) {
   state.projectApplicationStatusList = payload;
  },
  setProjectCompletionStatusList(state, payload) {
   state.projectCompletionStatusList = payload;
  },
  setProjectMarkList(state, payload) {
   state.projectMarkList = payload;
  },
  setProjectStatusList(state, payload) {
   state.projectStatusList = payload;
  },
  setProjectSectorList(state, payload) {
    state.projectSectorList = payload;
  },
  setProjectTypeList(state, payload) {
    state.projectTypeList = payload;
  },
  setProjectWorkTypeList(state, payload) {
   state.projectWorkTypeList = payload;
  },
  setProvinceList(state, payload) {
    state.provinceList = payload;
  },
  setRiskCostLevelList(state, payload) {
   state.riskCostLevelList = payload;
  },
  setRiskResourceAvailabilityLevelList(state, payload) {
   state.riskResourceAvailabilityLevelList = payload;
  },
  setRiskScheduleLevelList(state, payload) {
   state.riskScheduleLevelList = payload;
  },
  setRiskScopeLevelList(state, payload) {
   state.riskScopeLevelList = payload;
  },
  setRiverList(state, payload) {
   state.riverList = payload;
  },
  setRoadClassList(state, payload) {
   state.roadClassList = payload;
  },
  setRoadSurfaceList(state, payload) {
   state.roadSurfaceList = payload;
  },
  setRoadTypeList(state, payload) {
   state.roadTypeList = payload;
  },
  setRoadWorkTypeList(state, payload) {
   state.roadWorkTypeList = payload;
  },
  setUserProfileList(state, payload) {
   state.userProfileList = payload;
  },
  setUserTypeList(state, payload) {
   state.userTypeList = payload;
  },
  setVillageList(state, payload) {
    state.villageList = payload;
  },
  setYearList(state, payload) {
    state.yearList = payload;
  },
  setInstructionDocumentList(state, payload) {
    state.instructionDocumentList = payload;
  },
  setReportingDocumentList(state, payload) {
    state.reportingDocumentList = payload;
  },
  setCompletionDocumentList(state, payload) {
    state.completionDocumentList = payload;
  }
 
}

const actions = {
  getAssetTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/asset_types`).then(response => {
        commit('setAssetTypeList', response.data);
      }); 
    } catch(error){
      commit('setAssetTypeList', []);
    }
  },
  getBridgeCategoryList: ({ state, commit }) => {
    try{
        axios.get(`/api/bridge_categories`).then(response => {
        commit('setBridgeCategoryList', response.data);
      });
    } catch(error){
      commit('setBridgeCategoryList', []);
    }
  },
  getBridgeWorkTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/bridge_work_types`).then(response => {
        commit('setBridgeWorkTypeList', response.data);
      });
    } catch(error){
      commit('setBridgeWorkTypeList', []);
    }
  },
  getBuildingCategory: ({ state, commit }) => {
    try{
        axios.get(`/api/building_categories`).then(response => {
        commit('setBuildingCategory', response.data);
      });
    } catch(error){
      commit('setBuildingCategory', []);
    }
  },
  getBuildingMinistryList: ({ state, commit }) => {
    try{
        axios.get(`/api/building_ministries`).then(response => {
        commit('setBuildingMinistryList', response.data);
      });
    } catch(error){
      commit('setBuildingMinistryList', []);
    }
  },
  getBuildingTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/building_types`).then(response => {
        commit('setBuildingTypeList', response.data);
      });
    } catch(error){
      commit('setBuildingTypeList', []);
    }
  },
  getBuildingWorkTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/building_work_types`).then(response => {
        commit('setBuildingWorkTypeList', response.data);
      });
    } catch(error){
      commit('setBuildingWorkTypeList', []);
    }
  },
  getContractorExperienceList: ({ state, commit }) => {
    try{
        axios.get(`/api/contractor_experiences`).then(response => {
        commit('setContractorExperienceList', response.data);
      });
    } catch(error){
      commit('setContractorExperienceList', []);
    }
  },
  getContractorDocumentReferentialList: ({ state, commit }) => {
    try{
        axios.get(`/api/contractor_document_referential_list`).then(response => {
        commit('setContractorDocumentReferentialList', response.data);
      });
    } catch(error){
      commit('setContractorDocumentReferentialList', []);
    }
  },
  getCostCategoryList: ({ state, commit }) => {
    try{
        axios.get(`/api/cost_categories`).then(response => {
        commit('setCostCategoryList', response.data);
      });
    } catch(error){
      commit('setCostCategoryList', []);
    }
  },
  getDesignMethodList: ({ state, commit }) => {
    try{
        axios.get(`/api/design_methods`).then(response => {
        commit('setDesignMethodList', response.data);
      });
    } catch(error){
      commit('setDesignMethodList', []);
    }
  },
  getDisasterCategoryList: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/disaster_categories`).then(response => {
        axios.get(`/api/disaster_categories`).then(response => {
        commit('setDisasterCategoryList', response.data);
      });
    } catch(error){
      commit('setDisasterCategoryList', []);
    }
  },
  getDistrictList: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/districts`).then(response => {
        axios.get(`/api/districts`).then(response => {
        commit('setDistrictList', response.data);
      });
    } catch(error){
      commit('setDistrictList', []);
    }
  },
  getDistrictOfUserProfileList: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/villages`).then(response => {
        axios.get(`/api/get_district_of_user_profiles`).then(response => {
        commit('setDistrictOfUserProfileList', response.data);
      });
    } catch(error){
      commit('setDistrictOfUserProfileList', []);
    }
  },
  getDomainList: ({ state, commit }) => {
    try{
        axios.get(`/api/domains`).then(response => {
        commit('setDomainList', response.data);
      });
    } catch(error){
      commit('setDomainList', []);
    }
  },

  getEquipmentCategoryList: ({ state, commit }) => {
    try{
        axios.get(`/api/equipment_categories`).then(response => {
        commit('setEquipmentCategoryList', response.data);
      });
    } catch(error){
      commit('setEquipmentCategoryList', []);
    }
  },
  getEquipmentWorkTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/equipment_work_types`).then(response => {
        commit('setEquipmentWorkTypeList', response.data);
      });
    } catch(error){
      commit('setEquipmentWorkTypeList', []);
    }
  },
  getFunctionList: ({ state, commit }) => {
    try{
        axios.get(`/api/functions`).then(response => {
        commit('setFunctionList', response.data);
      });
    } catch(error){
      commit('setFunctionList', []);
    }
  },
  getFundingSourceList: ({ state, commit }) => {
    try{
        axios.get(`/api/funding_sources`).then(response => {
        commit('setFundingSourceList', response.data);
      });
    } catch(error){
      commit('setFundingSourceList', []);
    }
  },
  getIrrigationCategoryList: ({ state, commit }) => {
    try{
        axios.get(`/api/irrigation_categories`).then(response => {
        commit('setIrrigationCategoryList', response.data);
      });
    } catch(error){
      commit('setIrrigationCategoryList', []);
    }
  },
  getIrrigationTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/irrigation_types`).then(response => {
        commit('setIrrigationTypeList', response.data);
      });
    } catch(error){
      commit('setIrrigationTypeList', []);
    }
  },
  getIrrigationWorkTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/irrigation_work_types`).then(response => {
        commit('setIrrigationWorkTypeList', response.data);
      });
    } catch(error){
      commit('setIrrigationWorkTypeList', []);
    }
  },
  getMilestoneStatusList: ({ state, commit }) => {
    try{
        axios.get(`/api/milestone_status`).then(response => {
        commit('setMilestoneStatusList', response.data);
      });
    } catch(error){
      commit('setMilestoneStatusList', []);
    }
  },
  getProcurementTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/procurement_types`).then(response => {
        commit('setProcurementTypeList', response.data);
      });
    } catch(error){
      commit('setProcurementTypeList', []);
    }
  },
  getProjectClassList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_classes`).then(response => {
        commit('setProjectClassList', response.data);
      });
    } catch(error){
      commit('setProjectClassList', []);
    }
  },
  getProjectPictureCategoryList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_picture_categories`).then(response => {
        commit('setProjectPictureCategoryList', response.data);
      });
    } catch(error){
      commit('setProjectPictureCategoryList', []);
    }
  },
  getProjectApplicationStatusList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_application_status`).then(response => {
        commit('setProjectApplicationStatusList', response.data);

      });
    } catch(error){
      commit('setProjectApplicationStatusList', []);
    }
  },
  getProjectCompletionStatusList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_completion_status`).then(response => {
        commit('setProjectCompletionStatusList', response.data);
      });
    } catch(error){
      commit('setProjectCompletionStatusList', []);
    }
  },
  getProjectMarkList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_mark_list`).then(response => {
        commit('setProjectMarkList', response.data);
      });
    } catch(error){
      commit('setProjectMarkList', []);
    }
  },
  getProjectStatusList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_status`).then(response => {
        commit('setProjectStatusList', response.data);
      });
    } catch(error){
      commit('setProjectStatusList', []);
    }
  },
  getProjectSectorList: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/villages`).then(response => {
        axios.get(`/api/project_sectors`).then(response => {
        commit('setProjectSectorList', response.data);
      });
    } catch(error){
      commit('setProjectSectorList', []);
    }
  },
 getProjectTypeList: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/villages`).then(response => {
        axios.get(`/api/project_types`).then(response => {
        commit('setProjectTypeList', response.data);
      });
    } catch(error){
      commit('setProjectTypeList', []);
    }
  },
  getProjectWorkTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/project_work_types`).then(response => {
        commit('setProjectWorkTypeList', response.data);
      });
    } catch(error){
      commit('setProjectWorkTypeList', []);
    }
  },
  getProvinceList: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/provinces`).then(response => {
        axios.get(`/api/provinces`).then(response => {

          if(auth.state.user.user_profile_id !== 1){
            
            var province_list_of_user = response.data.filter(prov => prov.id === auth.state.user.province_id);
            commit('setProvinceList', province_list_of_user);

          }else{
            commit('setProvinceList', response.data);
          }

        //commit('setProvinceList', response.data);
      });
    } catch(error){
      commit('setProvinceList', []);
    }
  },
  getRiskCostLevelList: ({ state, commit }) => {
    try{
        axios.get(`/api/risk_cost_levels`).then(response => {
        commit('setRiskCostLevelList', response.data);
      });
    } catch(error){
      commit('setRiskCostLevelList', []);
    }
  },
  getRiskResourceAvailabilityLevelList: ({ state, commit }) => {
    try{
        axios.get(`/api/risk_resource_availability_levels`).then(response => {
        commit('setRiskResourceAvailabilityLevelList', response.data);
      });
    } catch(error){
      commit('setRiskResourceAvailabilityLevelList', []);
    }
  },
  getRiskScheduleLevelList: ({ state, commit }) => {
    try{
        axios.get(`/api/risk_schedule_levels`).then(response => {
        commit('setRiskScheduleLevelList', response.data);
      });
    } catch(error){
      commit('setRiskScheduleLevelList', []);
    }
  },
  getRiskScopeLevelList: ({ state, commit }) => {
    try{
        axios.get(`/api/risk_scope_levels`).then(response => {
        commit('setRiskScopeLevelList', response.data);
      });
    } catch(error){
      commit('setRiskScopeLevelList', []);
    }
  },
  getRiverList: ({ state, commit }) => {
    try{
        axios.get(`/api/rivers`).then(response => {
        commit('setRiverList', response.data);
      });
    } catch(error){
      commit('setRiverList', []);
    }
  },
  getRoadClassList: ({ state, commit }) => {
    try{
        axios.get(`/api/road_classes`).then(response => {
        commit('setRoadClassList', response.data);
      });
    } catch(error){
      commit('setRoadClassList', []);
    }
  },
  getRoadSurfaceList: ({ state, commit }) => {
    try{
        axios.get(`/api/road_surfaces`).then(response => {
        commit('setRoadSurfaceList', response.data);
      });
    } catch(error){
      commit('setRoadSurfaceList', []);
    }
  },
  getRoadTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/road_types`).then(response => {
        commit('setRoadTypeList', response.data);
      });
    } catch(error){
      commit('setRoadTypeList', []);
    }
  },
  getRoadWorkTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/road_work_types`).then(response => {
        commit('setRoadWorkTypeList', response.data);
      });
    } catch(error){
      commit('setRoadWorkTypeList', []);
    }
  },
  getUserProfileList: ({ state, commit }) => {
    try{
        axios.get(`/api/user_profiles`).then(response => {
        commit('setUserProfileList', response.data);
      });
    } catch(error){
      commit('setUserProfileList', []);
    }
  },
  getUserTypeList: ({ state, commit }) => {
    try{
        axios.get(`/api/user_types`).then(response => {
        commit('setUserTypeList', response.data);
      });
    } catch(error){
      commit('setUserTypeList', []);
    }
  },
  getVillageList: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/villages`).then(response => {
        axios.get(`/api/villages`).then(response => {
        commit('setVillageList', response.data);
      });
    } catch(error){
      commit('setVillageList', []);
    }
  },
  getYearList: ({ state, commit }) => {
    try{
        axios.get(`/api/years`).then(response => {
        commit('setYearList', response.data);
      });
    } catch(error){
      commit('setYearList', []);
    }
  },
  getInstructionDocumentList: ({ state, commit }) => {
    try{
        axios.get(`/api/instruction_document_list`).then(response => {
        commit('setInstructionDocumentList', response.data);
      });
    } catch(error){
      commit('setInstructionDocumentList', []);
    }
  },
  getReportingDocumentList: ({ state, commit }) => {
    try{
        axios.get(`/api/reporting_document_list`).then(response => {
        commit('setReportingDocumentList', response.data);
      });
    } catch(error){
      commit('setReportingDocumentList', []);
    }
  },
  getCompletionDocumentList: ({ state, commit }) => {
    try{
        axios.get(`/api/completion_document_list`).then(response => {
        commit('setCompletionDocumentList', response.data);
      });
    } catch(error){
      commit('setCompletionDocumentList', []);
    }
  }
}

const getters = {
  assetTypeList: state => {
    return state.assetTypeList
  },
  bridgeCategoryList: state => {
    return state.bridgeCategoryList
  },
  bridgeWorkTypeList: state => {
    return state.bridgeWorkTypeList
  },
  buildingCategory: state => {
    return state.buildingCategory
  },
  buildingMinistryList: state => {
    return state.buildingMinistryList
  },
  buildingTypeList: state => {
    return state.buildingTypeList
  },
  buildingWorkTypeList: state => {
    return state.buildingWorkTypeList
  },
  contractorExperienceList: state => {
    return state.contractorExperienceList
  },
  contractorDocumentReferentialList: state => {
    return state.contractorDocumentReferentialList
  },
  costCategoryList: state => {
    return state.costCategoryList
  },
  designMethodList: state => {
    return state.designMethodList
  },
  disasterCategoryList: state => {
    return state.disasterCategoryList
  },
  districtList: state => {
    return state.districtList
  },
  districtOfUserProfileList: state => {
    return state.districtOfUserProfileList
  },
  domainList: state => {
    return state.domainList
  },
  equipmentCategoryList: state => {
    return state.equipmentCategoryList
  },
  equipmentWorkTypeList: state => {
    return state.equipmentWorkTypeList
  },
  functionList: state => {
    return state.functionList
  },
  irrigationCategoryList: state => {
    return state.irrigationCategoryList
  },
  irrigationTypeList: state => {
    return state.irrigationTypeList
  },
  irrigationWorkTypeList: state => {
    return state.irrigationWorkTypeList
  },
  milestoneStatusList: state => {
    return state.milestoneStatusList
  },
  procurementTypeList: state => {
    return state.procurementTypeList
  },
  projectClassList: state => {
    return state.projectClassList
  },
  projectPictureCategoryList: state => {
    return state.projectPictureCategoryList
  },
  projectApplicationStatusList: state => {
    return state.projectApplicationStatusList
  },
  projectCompletionStatusList: state => {
    return state.projectCompletionStatusList
  },
  projectStatusList: state => {
    return state.projectStatusList
  },
  projectMarkList: state => {
    return state.projectMarkList
  },
  projectSectorList: state => {
    return state.projectSectorList
  },
  projectTypeList: state => {
    return state.projectTypeList
  },
  projectWorkTypeList: state => {
    return state.projectWorkTypeList
  },
  provinceList: state => {
    return state.provinceList
  },
  riskCostLevelList: state => {
    return state.RiskCostLevelList
  },
  riskResourceAvailabilityLevelList: state => {
    return state.RiskResourceAvailabilityLevelList
  },
  riskScheduleLevelList: state => {
    return state.RiskScheduleLevelList
  },
  riskScopeLevelList: state => {
    return state.RiskScopeLevelList
  },
  riverList: state => {
    return state.riverList
  },
  roadClassList: state => {
    return state.roadClassList
  },
  roadSurfaceList: state => {
    return state.roadSurfaceList
  },
  roadTypeList: state => {
    return state.roadTypeList
  },
  roadWorkTypeList: state => {
    return state.roadWorkTypeList
  },
  userProfileList: state => {
    return state.userProfileList
  },
  userTypeList: state => {
    return state.userTypeList
  },
  villageList: state => {
    return state.villageList
  },
  yearList: state => {
    return state.yearList
  },
  instructionDocumentList: state => {
    return state.instructionDocumentList
  },
  reportingDocumentList: state => {
    return state.reportingDocumentList
  },
  completionDocumentList: state => {
    return state.completionDocumentList
  }
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
